import React, { Component, useLayoutEffect, useRef } from "react";

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { useEffect } from "react";
import { useSelector } from "react-redux";

am4core.useTheme(am4themes_animated);

const YearlyYeildDataProduction = (props) => {
//  console.log(props.data , "YearlyYeildDataProduction")
 const lang_choiced = useSelector((state) => state.lang_change);
 // const dispatch = useDispatch();
 const chart = useRef(null);
 useLayoutEffect(() => {
   // Themes end

   // Create chart instance
   let x = am4core.create("chartdiv6", am4charts.XYChart);

   // Add data
   x.data = props.data

   // Create axes

   let categoryAxis = x.xAxes.push(new am4charts.CategoryAxis());
   categoryAxis.dataFields.category = "month";
   categoryAxis.renderer.grid.template.location = 0;
   categoryAxis.renderer.minGridDistance = 30;

   categoryAxis.renderer.labels.template.rotation = 90;
   categoryAxis.renderer.labels.template.horizontalCenter = "left";
   categoryAxis.renderer.labels.template.verticalCenter = "middle"

   categoryAxis.renderer.labels.template.adapter.add("dy", function (
     dy,
     target
   ) {
     if (target.dataItem && target.dataItem.index & (2 == 2)) {
       return dy + 25;
     }
     return dy;
   });

   let valueAxis = x.yAxes.push(new am4charts.ValueAxis());

   // Create series
   let series = x.series.push(new am4charts.ColumnSeries());
   series.dataFields.valueY = "energy";
   series.dataFields.categoryX = "month";
   series.name = "Monthly_Product";
   series.columns.template.tooltipText = "{categoryX}: [bold]{valueY}[/] kWh";
   series.columns.template.fillOpacity = 0.8;

   let columnTemplate = series.columns.template;
   columnTemplate.strokeWidth = 2;
   columnTemplate.strokeOpacity = 1;

   x.logo.opacity = 0;
   x.logo.display = "none";
   x.logo.color = "white";
   x.logo.height = 25;
   x.logo.width = 5;

   

   if (
     (window.document.documentElement.lang === "fa") &
     (window.document.documentElement.dir === "rtl")
   ) {
     x.rtl = true;
     // console.log("chart is rtl");
   } else {
     x.rtl = false;
     // console.log("chart is ltr");
   }
   // chart.rtl = window.document.documentElement.lang === "fa" ? true : false;
   x.responsive.enabled = true;

   x.exporting.menu = new am4core.ExportMenu();
   x.exporting.menu.height = -25;
   x.exporting.menu.align = "left";
   x.exporting.menu.verticalAlign = "bottom";
   x.exporting.menu.items = [
     {
       label: "...",
       menu: [
         {
           label: "Image",
           menu: [
             { type: "png", label: "PNG" },
             { type: "jpg", label: "JPG" },
             { type: "svg", label: "SVG" },
             { type: "pdf", label: "PDF" },
           ],
         },
         {
           label: "Data",
           menu: [
             { type: "json", label: "JSON" },
             { type: "csv", label: "CSV" },
             { type: "xlsx", label: "XLSX" },
             { type: "html", label: "HTML" },
             { type: "pdfdata", label: "PDF" },
           ],
         },
         {
           label: "Print",
           type: "print",
         },
       ],
     },
   ];
   x.exporting.filePrefix = Date();
   chart.current = x;

   return () => {
     x.dispose();
   };
 });

  return <div id="chartdiv6" style={{ height: "400px", width: "100%" }}></div>;
};

export default YearlyYeildDataProduction;
